import { useConfig } from '@common/Hooks/useConfig';
import { useTranslation } from '@common/Hooks/useTranslation';
import { SPONSORED_PRODUCT_MODAL_ID } from '@common/Product/Sponsor/constants/modalIds';
import ProductCardRedesign from '@common/ProductCard/containers/ProductCardRedesign';
import { CARD_TYPES } from '@common/ProductCard/helpers/constants';
import { ReactOnRailsRootComponent } from '@common/ReactOnRails';
import { KEVEL_ID, SPONSORED_CLICK_URL } from '@common/Tracking/constants/localStorage';
import { saveState } from '@helpers/localStorage';
import { SponsoredProductsModal } from './SponsoredProductsModal';

const MIDDLE_MOUSE_CLICK = 1;

export function SponsoredProductsCard({ product, trackingValues }) {
    const config = useConfig();
    const translate = useTranslation();
    const imageDimensions = Object.values(config.productCardImageDimensions);
    const bigListingImageDimension = config.productCardImageDimensions.large;
    const firstVariantId = product.variants[0].id;

    const handleClick = () => {
        saveState(SPONSORED_CLICK_URL, product.sponsored_product_tracking.click_url);
        saveState(KEVEL_ID, product.sponsored_product_tracking.ad_id);
    };

    const handleLinkContextMenuHandler = () => {
        saveState(SPONSORED_CLICK_URL, product.sponsored_product_tracking.click_url);
        saveState(KEVEL_ID, product.sponsored_product_tracking.ad_id);
    };

    const handleMouseDown = (event) => {
        if (event.button === MIDDLE_MOUSE_CLICK) {
            saveState(SPONSORED_CLICK_URL, product.sponsored_product_tracking.click_url);
            saveState(KEVEL_ID, product.sponsored_product_tracking.ad_id);
        }
    };

    return (
        <ProductCardRedesign
            key={firstVariantId}
            hasToShowFavoriteButton
            lazyLoad
            availableImageDimensions={imageDimensions}
            className="product-listing__card"
            imageSizes={{ dimension: bigListingImageDimension }}
            product={product}
            topHeaderComponent={product.sponsored_product_tracking && (
                <SponsoredProductsModal
                    hasSplash
                    id={`${SPONSORED_PRODUCT_MODAL_ID.listingPage}-${firstVariantId}`}
                    linkLabel={translate('sponsored_products.tooltip_link')}
                    linkURL={translate('sponsored_products.tooltip_url')}
                    message={translate('sponsored_products.tooltip_text')}
                    splash={translate('sponsored_products.splash')}
                    title={translate('sponsored_products.tooltip_title')}
                />
            )}
            trackingValues={trackingValues}
            type={CARD_TYPES.listingPage}
            onClick={handleClick}
            onLinkContextMenu={handleLinkContextMenuHandler}
            onMouseDown={handleMouseDown}
        />
    );
}

export default ReactOnRailsRootComponent(SponsoredProductsCard, { withReduxStore: true });
